module.exports = __webpack_public_path__ + "static/img/logo.a870b1ae.svg";